import React, { useState, useRef } from "react";
import {
  Modal as MuiBaseModal,
  Box,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import stylesModal from "../../styles/Atoms/ModalComponent/modal";

const MuiModal = ({
  title,
  subtitle,
  children,
  onClose,
  buttons,
  visible,
  width,
  height,
  overlayStyle,
  arrastrar = false,
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const boxRef = useRef(null);

  const handleMouseDown = (e) => {
    if (!arrastrar) return;
    setIsDragging(true);
    setDragStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !arrastrar) return;
    setPosition({
      x: e.clientX - dragStart.x,
      y: e.clientY - dragStart.y,
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Listener global para mouse move y up
  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging, dragStart, position]);

  return (
    <MuiBaseModal
      open={visible}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      disableEscapeKeyDown
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...overlayStyle,
      }}
    >
      <Box
        ref={boxRef}
        sx={{
          ...stylesModal.modal,
          width,
          height,
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.paper",
          maxHeight: "90vh",
          transform: arrastrar
            ? `translate(${position.x}px, ${position.y}px)`
            : "none",
          transition: isDragging ? "none" : "transform 0.1s",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            ...stylesModal.modalHeader,
            display: "flex",
            justifyContent: "space-between",
            cursor: arrastrar ? "move" : "auto",
            userSelect: "none",
          }}
          onMouseDown={handleMouseDown}
        >
          <Box>
            <Typography
              style={{
                ...stylesModal.modalHeaderH2,
                fontWeight: 600,
                fontSize: "1.5rem",
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                style={{
                  ...stylesModal.modalHeaderH4,
                  fontWeight: 400,
                  fontSize: "0.85rem",
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <IconButton onClick={onClose} sx={stylesModal.closeButton}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={stylesModal.modalDivider} />

        {/* Content */}
        <Box
          sx={{
            ...stylesModal.modalContent,
            flex: "1 1 auto",
            overflowY: "auto",
          }}
        >
          {children}
        </Box>

        {buttons && (
          <>
            <Box sx={stylesModal.modalButtons}>{buttons}</Box>
          </>
        )}
      </Box>
    </MuiBaseModal>
  );
};

export default MuiModal;
